import { createStyles } from '@material-ui/core/styles';

const stylesFormPersonalData = createStyles((theme) => ({
  form: {
    padding: '0 20px 10px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 0 10px 20px'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '20px 0 10px',
      width: '90%',
      margin: 'auto'
    }
  },
  marginBottomField: {
    marginBottom: '15px'
  },
  icon: {
    color: '#757575',
    fontSize: '1rem'
  },
  iconHover: {
    color: '#757575',
    fontSize: '1rem',
    cursor: 'pointer'
  },
  button: {
    margin: '10px 0 0',
    minWidth: '150px',
    borderRadius: 20
  }
}));

export default stylesFormPersonalData;